import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Confirmation } from '@abp/ng.theme.shared';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DialogModule } from 'primeng/dialog';
import { ConfirmationService } from '../confirmation.service';
import { ConfirmDialogState } from 'src/core/models/confirmation/confirm-dialog-state.model';
import { ConfirmSeverity } from 'src/core/models/confirmation/confirm-severity.model';

@Component({
  selector: 'app-confirm-dialog-host',
  standalone: true,
  imports: [DialogModule],
  templateUrl: './confirm-dialog-host.component.html',
  styleUrls: ['./confirm-dialog-host.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmDialogHostComponent implements OnInit, OnDestroy {
  private readonly confirmationService = inject(ConfirmationService);
  private readonly destroy$ = new Subject<void>();
  private closedViaButton = false;

  visible = false;
  state: ConfirmDialogState | null = null;

  ngOnInit(): void {
    this.confirmationService.dialogState$.pipe(takeUntil(this.destroy$)).subscribe(state => {
      this.state = state;
      this.visible = state !== null;
      this.closedViaButton = false;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.state) {
      this.state.answer$.next(Confirmation.Status.dismiss);
      this.state.answer$.complete();
      this.state = null;
    }
  }

  get iconClass(): string {
    const icons: Record<ConfirmSeverity, string> = {
      warn: 'fas fa-triangle-exclamation',
      info: 'fas fa-circle-info',
      error: 'fas fa-circle-xmark',
      success: 'fas fa-circle-check',
    };
    return icons[this.state?.severity ?? 'info'];
  }

  accept(): void {
    this.closedViaButton = true;
    this.state?.answer$.next(Confirmation.Status.confirm);
    this.state?.answer$.complete();
    this.visible = false;
  }

  reject(): void {
    this.closedViaButton = true;
    this.state?.answer$.next(Confirmation.Status.reject);
    this.state?.answer$.complete();
    this.visible = false;
  }

  onHide(): void {
    if (this.state && !this.closedViaButton) {
      this.state.answer$.next(Confirmation.Status.dismiss);
      this.state.answer$.complete();
    }
    this.state = null;
    this.closedViaButton = false;
  }
}
